import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";

import { colors } from "const/colors";

const HIDE_AFTER_MS = Date.UTC(2027, 0, 1);

const Bar = styled(Link)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	padding: 10px 24px;
	background: linear-gradient(90deg, ${colors.purple}, ${colors.blue} 55%, ${colors.teal});
	color: #fff;
	font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
	font-size: 15px;
	font-weight: 600;
	line-height: 1.3;
	text-align: center;
	letter-spacing: 0.01em;

	&:hover {
		color: #fff;
		filter: brightness(1.08);
	}

	@media (max-width: 768px) {
		padding: 9px 16px;
		font-size: 13px;
	}
`;

const Badge = styled.span`
	display: inline-flex;
	align-items: center;
	background: rgba(255, 255, 255, 0.18);
	border-radius: 999px;
	padding: 3px 10px;
	font-weight: 800;
	white-space: nowrap;
`;

const Detail = styled.span`
	font-weight: 500;

	@media (max-width: 720px) {
		display: none;
	}
`;

export default function LaunchBanner() {
	const router = useRouter();
	const [visible, setVisible] = useState(() => Date.now() < HIDE_AFTER_MS);

	useEffect(() => {
		setVisible(Date.now() < HIDE_AFTER_MS);
	}, []);

	const handleClick = useCallback(
		event => {
			if (router.pathname !== "/") return;
			event.preventDefault();
			document.getElementById("plus")?.scrollIntoView({ behavior: "smooth", block: "start" });
			window.history.replaceState(null, "", "/#plus");
		},
		[router.pathname]
	);

	if (!visible) return null;

	return (
		<Bar href="/#plus" onClick={handleClick}>
			<Badge>2.0</Badge>
			Wishbox 2.0 is out now
			<Detail>— AI, collaboration, and a faster app. Android is coming soon.</Detail>
		</Bar>
	);
}
